import React from 'react';
import CaseStudyLayout from '../../../components/caseStudy/index';
import { c2w } from '../image_index';
import { sections } from './config';

const ComparedToWhat = () => {
    return (
        <CaseStudyLayout
            title='Compared to What?'
            subtitle='Interactive Data Visualization & Mobile Web Design'
            heroImage={[c2w]}
            duration='May 2021 - June 2021'
            tools='Adobe XD, React/D3'
            role='UI/UX Prototype Designer, UX Research'
            summary={(
                <p>
                    A mobile web page designed based on Andrea Bowers’ neon light installation,{' '}
                    <a
                        href='https://manettishremmuseum.ucdavis.edu/education-should-be-free'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        Education Should Be Free
                    </a>
                    , to inform viewers of the rise in UC tuition compared to notable statistics, such as minimum wage and CPI, for my ECS 162 - Web Programming class.
                </p>
            )}
            sections={sections}
        />
    );
}

export default ComparedToWhat;